import React from "react";
import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import { rootPath } from "../../helpers/paths";

export function NotFound() {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Link to={rootPath()}>
          <Button type="primary">Back Home</Button>
        </Link>
      }
    />
  );
}
